<template>
  <div class="full-height row">
    <div class="col-12" style="padding-left: 50px; margin-top: 20px">
      <div
        v-for="state in jsonSate(forms[0].dadosForm.unitStateSamae)"
        :key="state.id"
        :style="`background-color: ${stateSamae[state.chCodigo].cor}; margin: 3px; padding: 5px 30px; float: left; border-radius: 10px;`"
      >
        {{ state.nmDescricao }}
      </div>
    </div>
    <div :class=" formsConsumerUnit ? 'col-6 row' : 'col-12 row'">
      <div class="col-12 row container-crud q-px-sm">
        <div class="fit">
          <div class="crud-title">
            <translate>SAMAE</translate>
          </div>
          <q-card class="q-px-sm">
            <q-card-section class="data-card-main grid-layout">
              <div
                v-for="(obj, index) in computedInputsTypeElements"
                :key="index"
                :class="getClassesByTheElement(obj)"
              >
                <label>{{ obj.label }}:</label>
                {{ formatedValue(model[obj.name], obj) }}
              </div>
            </q-card-section>
            <br/><br/><br/>
            <jt-data-table
              v-if="datatable"
              :api-mode="false"
              :data="data"
              :buttons="datatable.buttons"
              :fields="datatable.columns"
              noneselect
              :is-paginated="false"
            />
          </q-card>
        </div>
      </div>
    </div>
    <div class="col-6 row" v-if="formsConsumerUnit" >
      <div class="col-12 row container-crud q-px-sm">
        <div class="crud-title">
          <translate>WASTE</translate>
        </div>
        <div class="fit">
          <page-detail
            :forms="formsConsumerUnit"
            :name="name"
            :params="params"
            :parent="parent"
            button-hidden
            @action-button="actionButtonHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import unitStateSamae from '../UnitStateSamae.config.js'
import { repository } from 'jtech'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
const { pageDetail } = JtCrud

@Component({
  name: 'PageDetail',
  mixins: [pageDetail],
  components: { JtDataTable, pageDetail }
})
class PageDetail extends Vue {
  stateSamae = unitStateSamae;
  datatable = null;
  data = null;
  formsConsumerUnit = null;

  async created () {
    this.datatable = this.getModalDatatable(this.forms[0])
    this.data = this.getModalResidues(this.forms[0])
    if (this.forms[0].dadosForm.consumerUnit) {
      this.formsConsumerUnit = await repository.resolve(
        'consumerUnit.alterar',
        {
          id: this.forms[0].dadosForm.consumerUnit
        }
      )
    }
  }

  getModalDatatable (_form) {
    return _form.inputs.find((_input) => _input.type == 'DATATABLE')
  }

  getModalResidues (_form) {
    return _form.relacionamentos.fileLXSamaes
  }

  jsonSate (state) {
    if (state instanceof Array) {
      return state
    }
    return JSON.parse(state)
  }

  get formateInputsConsumerUnitArray () {
    if (this.formsConsumerUnit) {
      // eslint-disable-next-line no-undef
      return _.chain(this.formsConsumerUnit[0].inputs)
        .orderBy((input) => input.type === 'COMPOSICAO', ['asc'])
        .groupBy((input) =>
          input.type === 'COMPOSICAO' ? 'composition' : 'input'
        )
        .toPairs()
        // eslint-disable-next-line no-undef
        .map((item) => _.zipObject(['type', 'elements'], item))
        .value()
    } else return []
  }

  get computedInputsConsumerUnitTypeElements () {
    const inputs = this.formateInputsConsumerUnitArray.length
      ? this.formateInputsConsumerUnitArray.find((ci) => ci.type === 'input')
        .elements
      : []
    return inputs.filter((input) => input.type != 'DATATABLE')
  }
}
export default PageDetail
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

for num in 1 .. 12 {
  .col-start-{num} {
    grid-column-start: num;
  }
}

for num in 1 .. 13 {
  .col-end-{num} {
    grid-column-end: num;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: max-content;
}

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-main.q-card__section {
  height: calc(100% - 65px);
  overflow: hidden;
  padding: 15px 0;
}

.data-card-main.q-card__section > div {
  padding: 5px 12px;
}

.data-card-main.q-card__section > div > label {
  font-weight: bold;
}

.row-grey {
  background: $ice;
}
</style>
